export default "__VITE_ASSET__BZooHlB0__"